import {
  ChangeDetectorRef,
  Component,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';
import {filter} from 'rxjs';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {BilletsService} from '../../services/billets.service';
import {cookiesService} from '../../services/cookies.service';
import {SettingsService} from '../../services/settings.service';

@Component({
  selector: 'cookie-political-page',
  templateUrl: './cookie_political.component.html',
  imports: [


  ],
  styleUrl: './cookie_political.component.less'
})
export class CookiePoliticalPageComponent {

  constructor(public SettingsService: SettingsService, private cd: ChangeDetectorRef, private cookies: cookiesService, public BilletsService: BilletsService, private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object, private router: Router, private title: Title, private meta: Meta) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {

          this.titleLoad()

          window.scrollTo({
            top: 0,
            behavior: 'smooth' // или убери behavior для мгновенного скролла
          });
        }
      });

  }





  ngOnInit(): void {
    this.titleLoad()
  }

  titleLoad() {

    this.title.setTitle('Политика использования cookie 🍪 | ПДД');

    this.meta.updateTag({
      name: 'description',
      content: 'Политика использования файлов cookie на сайте ПДД. Информация о том, какие данные сохраняются, для чего используются cookie и как управлять настройками браузера.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'политика cookie, cookies, файлы cookie, обработка данных, настройки cookie, пдд'
    });
  }

}
